import { useState } from "react";
import type { Ref } from "react";

import { View1 } from "../Icon/View1";
import { ViewOff } from "../Icon/ViewOff";
import { Input } from "../Input/Input";
import type { InputProps } from "../Input/Input";

import * as styles from "./PasswordInput.module.scss";

type PasswordInputProps = InputProps & { ref?: Ref<HTMLInputElement> };

const PasswordInput = ({ ref, ...props }: PasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const onClick = () => setShowPassword((prev) => !prev);
  const IconComponent = showPassword ? ViewOff : View1;
  return (
    <Input
      ref={ref}
      icon={<IconComponent className={styles.icon} onClick={onClick} />}
      type={showPassword ? "text" : "password"}
      {...props}
    />
  );
};

PasswordInput.displayName = "PasswordInput";

export { PasswordInput };
export type { PasswordInputProps };
